module.exports = __webpack_public_path__ + "img/img_engineering_banner.698f221a.png";